function ContentDescription({property}) {
    return (
        <div>
              <div
                className="text_body_p border_bottom_body"
                dangerouslySetInnerHTML={{ __html: property?.data?.description }}
            />
        </div>
    )
}

export default ContentDescription
